import { useEffect, useRef, useState } from 'react'
import { buildHealthCourseOnboardingUrl } from 'Lib/HealthCourseUtils'
import { ApiService } from 'Services/Api.service'

interface HealthCourseOnboardingUrl {
  url: string
  hasToken: boolean
}

/**
 * Resolves the health course onboarding URL for the signed-in user, minting the
 * token that attaches a purchase to their existing account.
 * @param enabled pass the same condition that decides whether the block renders,
 * so no token is minted for users who will never see it.
 */
const useHealthCourseOnboardingUrl = (enabled: boolean): HealthCourseOnboardingUrl => {
  const [token, setToken] = useState<string | null>(null)
  const hasRequested = useRef(false)

  useEffect(() => {
    if (!enabled || hasRequested.current) return
    hasRequested.current = true

    ApiService.createHealthCourseOnboardingToken()
      .then(minted => { setToken(minted) })
      .catch(error => { logError('web_healthCourseTokenError', error) })
  }, [enabled])

  return {
    url: buildHealthCourseOnboardingUrl(token),
    hasToken: token !== null
  }
}

export default useHealthCourseOnboardingUrl
